/**
 * Shared key for the coupon handed from the upgrade dialog to the account
 * subscription tab.
 *
 * The dialog validates a coupon server-side, then redirects to
 * `/account?tab=subscription`, which owns the Stripe checkout call. A query
 * param cannot carry it: `pages/account.tsx` rewrites the URL to
 * `?tab=<current>` on mount, dropping anything extra before the tab renders.
 *
 * sessionStorage is scoped to the tab and dies with it, so a coupon cannot leak
 * into a later browser session. The consumer clears it once read, so it applies
 * to exactly one checkout.
 */
export const UPGRADE_COUPON_STORAGE_KEY = 'realty_upgrade_coupon'

/** Read and clear the pending coupon. Returns null when none is set. */
export const takePendingUpgradeCoupon = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const coupon = window.sessionStorage.getItem(UPGRADE_COUPON_STORAGE_KEY)

    if (coupon) {
      window.sessionStorage.removeItem(UPGRADE_COUPON_STORAGE_KEY)
    }

    return coupon?.trim() || null
  } catch {
    // Private-mode / disabled storage: degrade to no coupon rather than throw.
    return null
  }
}
